import React from "react"
import Modal from "@components/modal"
import BlockHero from "@components/common/blockHero"
import ModalActuacionContent from "@components/common/modalActuacionContent"
import Image from "@images/actuacion/modal/impulsamos/impulsamos.png"

import IconsGroup from "@images/actuacion/modal/impulsamos/iconsGruop.jpg"

import Icon3 from "@images/icons/es/cert-icon-03.png"
import Icon4 from "@images/icons/es/cert-icon-04.png"
import Icon5 from "@images/icons/es/cert-icon-05.png"
import Icon8 from "@images/icons/es/cert-icon-08.png"
import Icon10 from "@images/icons/es/cert-icon-10.png"
import BlockNumber from "@components/common/blockNumber"

import ChangeModalBtn from "@components/common/changePageBtn"

const Impulsamos = () => {
  return (
    <Modal title="Nuestra actuación en 2020">
      <div className="mainModal-container">
        <div className="element">
          <BlockHero>
            <div className="title">Impulsamos</div>
            <div className="subtitle">
              el desarrollo personal y profesional de nuestros empleados
            </div>
            <div className="description">
              El desarrollo personal y profesional de los empleados es uno de
              los motores de crecimiento de Mutua Universal. La profesionalidad
              de los equipos ha llevado a que la Entidad sea considerada una
              mutua de referencia en calidad y capacidad de servicio.
            </div>
          </BlockHero>
        </div>
        <div className="element impulsamos">
          <ModalActuacionContent>
            <div className="row">
              <div className="image">
                <img src={Image} alt=""></img>
              </div>
            </div>
            <div className="row">
              <div className="container">
                <div className="sideA">
                  <div className="title">
                    Máxima prioridad: la protección de la salud y seguridad de
                    los profesionales de la Entidad
                  </div>
                  <div className="subtitle">
                    Desde la declaración del estado de alarma y a lo largo del
                    ejercicio, Mutua Universal ha aplicado todas las medidas
                    necesarias para garantizar la protección de sus
                    profesionales ante el riesgo de contagio.
                  </div>
                  <div className="list">
                    <p>
                      De forma inmediata, Mutua Universal aplicó la modalidad de
                      teletrabajo, quedando delimitada la actividad presencial a
                      los centros asistenciales en calidad de servicios mínimos.
                    </p>
                    <p>
                      En la vuelta progresiva de los profesionales asistenciales
                      a los centros se han aplicado medidas preventivas, se han
                      difundido fichas informativas sobre las medidas a seguir y
                      se han realizado sesiones específicas de formación.
                      También se ha activado el servicio de ayuda psicológica
                      para los trabajadores que lo necesiten y se ha
                      desarrollado una aplicación con recursos para la salud
                      emocional.
                    </p>
                  </div>
                  <div className="number">
                    <span>1.883</span>
                    <span>
                      empleados comprometidos con el propósito de Mutua
                      Universal de ser socialmente responsable y contribuir a la
                      sostenibilidad d el estado del bienestar.
                    </span>
                  </div>
                </div>
                <div className="sideB">
                  <div className="title">equipo humano</div>
                  <BlockNumber topText="" num="1.883" bottomText="empleados" />
                  <BlockNumber
                    topText=""
                    num="47,02"
                    bottomText="años de promedio de edad"
                  />
                  <BlockNumber
                    topText=""
                    num="15,09"
                    bottomText="años de antigüedad media"
                  />
                  <BlockNumber
                    topText=""
                    num="82%"
                    bottomText="profesionales con titulación superior"
                  />
                  <BlockNumber
                    topText=""
                    num="27"
                    bottomText="nacionalidades"
                  />
                  <BlockNumber
                    topText=""
                    num="35"
                    bottomText="empleados con discapacidad reconocida"
                  />
                  <BlockNumber
                    topText=""
                    num="97%"
                    bottomText="contratos indefinidos"
                  />
                  <BlockNumber
                    topText=""
                    num="72%"
                    bottomText="a tiempo completo"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="title">
                ods de impacto directo en acciones de prevención
              </div>
              <div className="icons">
                <img src={Icon3} alt=""></img>
                <img src={Icon4} alt=""></img>
                <img src={Icon5} alt=""></img>
                <img src={Icon8} alt=""></img>
                <img src={Icon10} alt=""></img>
              </div>
            </div>
            <div className="row">
              <div className="container">
                <div className="side">
                  <div className="title">
                    Salud y bienestar en tiempos de coronavirus
                  </div>
                  <div className="description">
                    La cuarta edición de la Semana de la Salud, desarrollada en
                    el marco del Programa de Salud Corporativa +Salud +Vida,
                    también se ha centrado en la salud y el bienestar en tiempos
                    de la COVID-19 (consejos sobre alimentación saludable,
                    técnicas de relajación, clases de iniciación al pilates o
                    materiales sobre bienestar emocional).
                  </div>
                  <div className="numbers fixSize">
                    <BlockNumber
                      topText=""
                      num="2.387"
                      bottomText="visitas únicas a la web+Salud+Vida"
                    />
                    <BlockNumber
                      topText=""
                      num="2.250"
                      bottomText="visitas únicas a vídeos de la Semana de la Salud"
                    />
                  </div>
                </div>
                <div className="side">
                  <div className="iconsImage">
                    <img src={IconsGroup} alt=""></img>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="container">
                <div className="side">
                  <div className="title">Programas de formación</div>
                  <div className="blockNumbers">
                    <div className="block">
                      <BlockNumber topText="" num="585" bottomText="cursos" />
                      <BlockNumber
                        topText=""
                        num="9.831"
                        bottomText="participantes"
                      />
                      <BlockNumber topText="" num="40.238" bottomText="horas" />
                    </div>
                    <div className="block">
                      <BlockNumber
                        topText=""
                        num="91%"
                        bottomText="horas de formación a distancia"
                      />
                      <BlockNumber
                        normal={true}
                        topText=""
                        num="8,9"
                        bottomText={`satisfacción y eficacia (sobre 10)`}
                      />
                    </div>
                  </div>
                </div>
                <div className="side">
                  <div className="title">
                    Adaptación de contenidos de formación en la Universidad
                    Corporativa
                  </div>
                  <div className="description">
                    La actividad de la Universidad Corporativa también se ha
                    visto afectada por la pandemia: se ha suspendido toda la
                    actividad presencial y se ha adaptado parte de los
                    contenidos previstos para ofrecer conocimiento especializado
                    sobre las nuevas herramientas y servicios desarrollados por
                    la Entidad.
                  </div>
                </div>
              </div>
            </div>
          </ModalActuacionContent>
        </div>
        <div className="changeBtn">
          <ChangeModalBtn />
        </div>
      </div>
    </Modal>
  )
}

export default Impulsamos
